<template>
    <base-input
        v-model="document"
        v-mask="'###.###.###-##'"
        v-validate="'required'"
        :name="$t('login.document')"
        :placeholder="'CPF'"
        prepend-icon="ni ni-badge"
    ></base-input>
</template>
<script>
import BaseInput from '../../argon/components/Inputs/BaseInput';

export default {
    emits: ['input', 'update:modelValue'],
    name: 'ChangePaymentDocument',
    props: {
        modelValue: Object,
    },
    components: {
        BaseInput,
    },
    computed: {
        model: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
                this.$emit('input', value);
            },
        },
        document: {
            get() {
                return this.model.document;
            },
            set(document) {
                this.model = { ...this.model, document };
            },
        },
        studentDocumentType() {
            const { document_type: type } = this.$store.getters.STUDENT;
            return type;
        },
        studentDocument() {
            return this.$store.getters.STUDENT?.document;
        },
    },
    mounted() {
        if (this.studentDocumentType === 'CPF') {
            this.model.document_type = 'CPF';
            this.document = this.studentDocument;
        }
    },
};
</script>
